import { render } from "./BackupsResponsabilitiesWidget.vue?vue&type=template&id=1aa29e56&scoped=true"
import script from "./BackupsResponsabilitiesWidget.vue?vue&type=script&lang=js"
export * from "./BackupsResponsabilitiesWidget.vue?vue&type=script&lang=js"

import "./BackupsResponsabilitiesWidget.vue?vue&type=style&index=0&id=1aa29e56&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Utilizador\\Desktop\\projetos\\owlpharma-hrm\\src\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1aa29e56"]])

export default __exports__